const AdmZip = require('adm-zip');
const axios = require('axios');
const fs = require('fs');
import log from 'electron-log';

async function downloadImage(url: any, path: string) {
  const response = await axios({
    url,
    method: 'GET',
    responseType: 'stream'
  });

  response.data.pipe(fs.createWriteStream(path));
  return new Promise<void>((resolve, reject) => {
    response.data.on('end', () => {
      resolve();
    });
    response.data.on('error', (err: any) => {
      log.error('downloadImage error', err)
      reject(err);
    });
  });
}

export async function batchDownloadImages(urls: string | any[], zipFile: any) {
  log.info('batchDownloadImages urls', urls)
  const zip = new AdmZip();
  for (let i = 0; i < urls.length; i++) {
    const url = urls[i];
    const fileName = urls[i].split("/").pop();
    log.info('batchDownloadImages fileName url', fileName, url)
    await downloadImage(url, fileName);
    zip.addLocalFile(fileName);
  }
  zip.writeZip(zipFile);
}
